import React, { useContext, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FiChevronDown, FiMenu, FiX } from "react-icons/fi";
import { CartContext } from "./CartContext";
import siteConfig from "../Datas/siteConfig";
import "../css/header.scss";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const quantity = cartItems.reduce((total, item) => total + item.quantity, 0);
  const closeMenu = () => {
    setMenuOpen(false);
    setMoreOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const links = [
    ["/shop", "Shop All"],
    ["/shop?category=Storage", "Storage"],
    ["/shop?category=Kitchen", "Kitchen"],
    ["/shop?category=Market", "Market"],
    ["/about", "Our Story"],
  ];
  const policyLinks = [
    ["/privacy", "Privacy"],
    ["/terms", "Terms"],
    ["/cookies", "Cookies"],
    ["/faqs", "FAQs"],
    ["/shipping", "Shipping"],
    ["/returns", "Returns"],
  ];

  return (
    <>
      <div className="announcement">STANDARD SHIPPING $9.99</div>
      <header className="site-header">
        <button
          className="header-icon mobile-menu"
          onClick={() => setMenuOpen(true)}
          aria-label="Open menu"
        >
          <FiMenu />
        </button>
        <Link
          to="/"
          onClick={closeMenu}
          className="wordmark"
          aria-label={siteConfig.brandName}
        >
          <span className="logo-mark">A</span>
          <strong>aovabasket</strong>
        </Link>
        <nav className="desktop-nav" aria-label="Primary navigation">
          {links.map(([to, label]) => (
            <NavLink key={label} to={to} onClick={closeMenu}>
              {label}
            </NavLink>
          ))}
          <div className="more-menu">
            <button
              onClick={() => setMoreOpen(!moreOpen)}
              aria-expanded={moreOpen}
            >
              More <FiChevronDown />
            </button>
            {moreOpen && (
              <div>
                {policyLinks.map(([to, label]) => (
                  <Link key={label} to={to} onClick={closeMenu}>
                    {label}
                  </Link>
                ))}
              </div>
            )}
          </div>
        </nav>
        <div className="header-actions">
          <Link
            to="/cartpage"
            aria-label={`Cart with ${quantity} items`}
            className="cart-link"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              className="icon icon-cart-empty"
              viewBox="0 0 40 40"
              width={35}
              height={30}
            >
              <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33L28.4 11.8zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1-9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z"
              />
            </svg>

            <span>{quantity}</span>
          </Link>
        </div>
      </header>
      <div
        className={`mobile-drawer ${menuOpen ? "open" : ""}`}
        aria-hidden={!menuOpen}
      >
        <button onClick={() => setMenuOpen(false)} aria-label="Close menu">
          <FiX />
        </button>
        {links.map(([to, label]) => (
          <Link key={label} to={to} onClick={closeMenu}>
            {label}
          </Link>
        ))}
        <button className="mobile-more" onClick={() => setMoreOpen(!moreOpen)}>
          More <FiChevronDown />
        </button>
        {moreOpen &&
          policyLinks.map(([to, label]) => (
            <Link
              className="mobile-policy"
              key={label}
              to={to}
              onClick={closeMenu}
            >
              {label}
            </Link>
          ))}
        <Link to="/contact" onClick={closeMenu}>
          Contact
        </Link>
      </div>
      {menuOpen && (
        <button
          className="drawer-backdrop"
          onClick={() => setMenuOpen(false)}
          aria-label="Close menu"
        />
      )}
    </>
  );
}
export default Header;
